import React from "react";
import { Space, Typography } from "antd";
import "./About.css";

const { Title, Text, Link } = Typography;

function About() {
  return (
    <>
      <Space
        id="text-about"
        align={"center"}
        direction={"vertical"}
        size={20}
        className="center-content"
      >
        <Title level={2} style={{ padding: "100px 0" }}>
          Visual Content Assessment Tool is an interactive dashboard. It is
          designed to track the visual content within articles curated by
          Wikiprojects, and helps contributors bridge gaps in visual content.
        </Title>
        <Title level={4}>Why a tool</Title>
        <Text>
          To monitor the progress of articles, many Wikiprojects use the system
          of{" "}
          <Link
            href="https://en.wikipedia.org/wiki/Wikipedia:Content_assessment"
            target="_blank"
          >
            Content assessment
          </Link>
          , which generates tables through{" "}
          <Link
            href="https://en.wikipedia.org/wiki/User:WP_1.0_bot"
            target="_blank"
          >
            WP 1.0 bot{" "}
          </Link>
          accessible at{" "}
          <Link href="https://wp1.openzim.org/#/" target="_blank">
            wp1.openzim.org
          </Link>
          . These tables allow the identification of incomplete articles that
          require focused editing and efforts to enhance their quality.
          <br /> <br />
          The presence of images is a defining characteristic of high-quality
          encyclopedia articles (as stated in the{" "}
          <Link
            href="https://en.wikipedia.org/wiki/Wikipedia:Featured_article_criteria"
            target="_blank"
          >
            Featured article criteria
          </Link>
          ). But identify articles where images should be inserted, modified, or
          created is not as easy as identifying missing textual information.
          <br />
          <br />
          This tool could bridge this gap and assist in identifying articles
          that need improvement in terms of visual content, thereby increasing
          the overall quality of the articles.
        </Text>

        <div className="divider-medium"></div>

        <Title level={4}>How it works</Title>
        <Text>
          To extract data related to articles in a Wikiproject the Extraction
          Tool uses{" "}
          <Link href="https://api.wp1.openzim.org/" target="_blank">
            WP 1.0 API
          </Link>
          , while to extract data related to images in each article it uses{" "}
          <Link
            href="https://www.mediawiki.org/wiki/API:Main_page"
            target="_blank"
          >
            MediaWiki Action API
          </Link>
          . The dashboard uses React.js and the UI library Ant Design to filter
          and display the data contained in a .JSON file produced by the
          Extraction Tool.
          <br /> <br />
          If you are curious about the extraction process take a look at the
          <Link
            href="https://github.com/Aquets/VCAT-data-extractor/tree/main/Source%20code"
            target="_blank"
          >
            {" "}
            source code
          </Link>{" "}
          of the Extraction Tool
        </Text>

        <div className="divider-medium"></div>

        <Title level={4}>Contacts</Title>
        <Text>
          This is a project by{" "}
          <Link
            href="https://en.wikipedia.org/wiki/User:MingoBerlingo"
            target="_blank"
          >
            User:MingoBerlingo
          </Link>
          . It is part of a larger study about visual content on Wikipedia and
          collaboration practices around images on Wikipedia.
          <br /> <br />
          If you have any question or suggestion contact me on Wikipedia, leave
          a message on my{" "}
          <Link
            href="https://en.wikipedia.org/w/index.php?title=User_talk:MingoBerlingo"
            target="_blank"
          >
            talk page
          </Link>{" "}
          or send me an email. If you find this project interesting leave your
          feedback filling the <Link target="_blank">form</Link>.
        </Text>
      </Space>
      <div className="divider-big"></div>
    </>
  );
}

export default About;
